<div class="autosuggest__listItem" role="option">
    <a class="autosuggest__link" role="presentation" id="{{uniqueItemID}}">{{displayKey}}</a>
</div>
